import { useState } from 'react';
import { Box, Grid } from '@mui/material';

import theme from 'theme';
import HardwareRequestsTable from './HardwareRequestsTable';

const HardwareRequests = () => {
  const [requests, setRequests] = useState([]);

  return (
    <Box sx={{ padding: theme.spacing(4) }}>
      <Grid item lg={12} md={12} xl={12} xs={12}>
        <HardwareRequestsTable requests={requests} setRequests={setRequests} />
      </Grid>
    </Box>
  );
};

export default HardwareRequests;
